import { isLinkOk, isLinkError } from "@common/utils/devices/summary";

import { Device, DeviceStatus } from "@services/devices/types";

// Monitoring bar statuses specs defined in SF-3354
export const getStatus = (
  isStatusOk: typeof isLinkOk,
  isStatusError: typeof isLinkError,
  device?: Device,
  status?: DeviceStatus,
  canAITroubleshoot?: boolean
): "unknown" | "success" | "troubleshooting" | "error" => {
  if (device === undefined || status === undefined) {
    return "unknown";
  }

  if (isStatusOk({ ...device, status })) {
    return "success";
  }

  if (isStatusError({ ...device, status })) {
    if (canAITroubleshoot) return "troubleshooting";
    else return "error";
  }

  return "unknown";
};
